import {createApp} from "vue";
import FaqPage from './FaqPage.vue'

const app = createApp(FaqPage);
app.mount("#faq-page");
